import { buildPayloadApiUrl, payloadFetch } from "./client";
import { getPublishedScheduleWhereParams } from "./scheduleWhereParams";
import { mapPromotionsResponse } from "src/utils/mapPromotion";

/**
 * Fetches promotion hub cards from pg-payload-cms.
 * Only returns promotions within their publish window (unpublishAt not yet passed).
 * @param {string} locale - `en` | `fr`
 * @returns {Promise<import('src/utils/mapPromotion').PromotionCard[]>}
 */
export async function fetchPromotions(locale) {
  const url = buildPayloadApiUrl("/api/promotions", {
    locale,
    limit: 200,
    sort: "_order",
    depth: 0,
    ...getPublishedScheduleWhereParams(),
  });

  const response = await payloadFetch(url);
  return mapPromotionsResponse(response, locale);
}
